module.exports = __webpack_public_path__ + "img/gab.29f203bb.svg";